<template>
  <div>
    <div style="width: 20cm; margin: 2mm auto">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <div id="print">
      <div style="page-break-after: always; margin-bottom: 50px" v-for="item in deliveryBills" :key="item.pkid">
        <div class="printItem">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <td rowspan="3" style="width: 130px; border-bottom: none">
                <div :id="'qrCode' + item.billNO" align="center" />
              </td>
              <td colspan="2" style="font-weight: 700; font-size: 14px" align="center">收货单</td>
            </tr>
            <tr>
              <td>单据编号：{{ item.billNO }}</td>
              <td>采购单号：{{ item.purchaseOrderNo }}</td>
            </tr>
            <tr>
              <td>供应商：{{ item.supplierName }}</td>
              <td>收货时间：{{ item.receiptTime }}</td>
            </tr>
          </table>
        </div>
        <div class="printItem">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <td style="width: 150px">物料编号</td>
              <td>物料名称</td>
              <td>规格</td>
              <td align="center" style="width: 80px">数量</td>
              <td align="center" style="width: 80px">单位</td>
            </tr>
            <tr v-for="i in item.billDetails" :key="i.pkid">
              <td>{{ i.materialNo }}</td>
              <td>{{ i.materialName }}</td>
              <td>{{ i.specification }}</td>
              <td align="center">{{ i.receiptQuantity }}</td>
              <td align="center">{{ i.unitName }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      deliveryBills: [],
    };
  },

  mounted() {
    this.getData(this.$route.query.params);
  },

  methods: {
    getData(ids) {
      this.$http.get("basic", `deliveryBills/getAllListByIds/${ids}`).then((resp) => {
        this.deliveryBills = resp.data;
        for (let item of this.deliveryBills) {
          this.$nextTick(() => {
            document.getElementById("qrCode" + item.billNO).innerHTML = "";
            this.bindQRCode(item.billNO);
          });
        }
      });
    },

    bindQRCode(code) {
      new QRCode(document.getElementById("qrCode" + code), {
        text: code,
        width: 110,
        height: 110,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    printHandle() {
      document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
      window.print();
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.printItem {
  width: 20cm;
  border: 1px solid #111;
  font-size: 10px;
  margin: 10px auto;
  table {
    width: 100%;
    tr {
      td {
        border-bottom: 1px solid #111;
        border-right: 1px solid #111;
        padding: 10px 5px;
        &:last-child {
          border-right: none;
        }
      }
      &:last-child td {
        border-bottom: none;
      }
    }
  }
}

@media print {
  .printBtn {
    display: none;
  }
}
</style>
